import type { SxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

export const spreadSxProperty = (sx: SxProps<Theme>) => {
  return Array.isArray(sx) ? sx : [sx];
};
